import React from "react";
import TableHeader from "./TableHeader";
import Table from "react-bootstrap/Table";
import TableRow from "./TableRow";
import "../tables/_static/TableView.css"


function ServiceTable(props) {
    return (
        <Table striped bordered hover responsive fullWidthTable>
            <TableHeader/>
            <tbody>
                {props.data && props.data.map((item, index) => {
                    return (
                        <TableRow key={index} data={item}/>
                    )
                })}
            </tbody>
        </Table>
    )
}

export default ServiceTable
